import { EntityUIState } from '../request/interfaces/entity-ui-state';
import { ListActions, ListActionType } from './list-actions';
import { PaginationStrategy } from './pagination-strategy';
import { ListConductorQueryParams } from './navigation-provider';

export interface OffsetPaginationData {
  totalCount?: number;
  page: number;
  limit: number;
}

export class OffsetPaginationStrategy extends PaginationStrategy<OffsetPaginationData> {
  constructor(private _pageSize: number) {
    super();
  }

  applyAction(action: ListActions, paginationData: OffsetPaginationData): OffsetPaginationData {
    let newData: OffsetPaginationData = {
      page: paginationData.page,
      totalCount: paginationData.totalCount,
      limit: this._pageSize
    };

    switch (action.type) {
      case ListActionType.NEXT:
        newData.page += 1;
        break;
      case ListActionType.PREVIOUS:
        newData.page -= 1;
        break;
      case ListActionType.RESPONSE:
        newData.totalCount = action.data.count;
        this.isLastPage = (newData.page + 1) * this._pageSize >= newData.totalCount;
        break;
      case ListActionType.REFRESH:
        break;
      case ListActionType.UPDATE_PAGE_SIZE:
        this._pageSize = action.data.pageSize;

        newData = {
          ...newData,
          limit: action.data.pageSize
        };

        break;
      default:
        break;
    }

    return newData;
  }

  getDataFromQueryParams(
    queryParamsPrefix: string,
    queryParams: ListConductorQueryParams,
    paginationData: OffsetPaginationData
  ): OffsetPaginationData {
    const pageNumberString = queryParams[`${queryParamsPrefix}_page`] as string;
    const pageNumberParsed = parseInt(pageNumberString, 10);

    return {
      page: pageNumberString && pageNumberParsed >= 0 ? pageNumberParsed : 0,
      limit: this._pageSize,
      totalCount: paginationData.totalCount
    };
  }

  getQueryParamsFromData(queryParamsPrefix: string, paginationData: OffsetPaginationData) {
    return {
      [`${queryParamsPrefix}_page`]: paginationData.page
    };
  }

  getDefaultPaginationData(): OffsetPaginationData {
    return {
      page: 0,
      limit: this._pageSize,
      totalCount: undefined
    };
  }

  getNetworkParams(paginationData: OffsetPaginationData) {
    return {
      page: paginationData.page,
      limit: paginationData.limit
    };
  }

  isFirstPage(paginationData: OffsetPaginationData) {
    return !paginationData.page;
  }

  getListState(filtersLength: number, total: number) {
    if (total > 0) {
      return EntityUIState.IDLE;
    }

    if (filtersLength === 0) {
      return EntityUIState.NEW;
    }

    return EntityUIState.EMPTY;
  }
}
